import { components, constants, useTranslation, useServices, useWhiteLabelServiceSettings } from 'cng-web-lib'
import AciHighwayCargoApiUrls from 'src/apiUrls/AciHighwayCargoApiUrls'
import NaCodeMaintenanceApiURLs from 'src/apiUrls/NaCodeMaintenanceApiUrls'
import React, { useEffect, useRef, useState,useContext } from 'react'
import AciHighwayCargoKeys from 'src/constants/locale/key/AciHighwayCargo'
import Namespace from 'src/constants/locale/Namespace'
import pathMap from 'src/paths/pathMap'
import moment from 'moment-timezone'
import Table from '../../../components/aciacehighway/Table'
import TinyChip from '../../../components/aciacehighway/TinyChip'
import ConfirmDialog from '../../common/ConfirmDialog'
import { Box, Chip, Typography, Tooltip, useTheme, Grid } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { format } from 'date-fns'
import { getStatusMetadata } from '../../../common/NACommon'
import { FileForUserGetPartyId,FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import sweetalert from 'sweetalert'
import TemplateSelectDialogWithOptionACIHWYCargo from 'src/components/aciacehighway/TemplateSelectDialogWithOptionACIHWYCargo'
import ResponseMessage from 'src/views/acihighway/response/ResponseMessage.js'
import { ACIHighwayTranslationContext } from '../contexts/ACIHighwayTranslationContext'
import ACIHighwayCargoTranslationText from './../contexts/ACIHighwayCargoTranslationText'


const {
  button: { CngButton },
  table: { useFetchCodeMaintenanceLookup },
  CngDialog
} = components

const {
  locale: {
    key: { UiComponentKeys }
  },
  filter: { BETWEEN, EQUAL, IN, LIKE }
} = constants

function TablePage(props) {
  const { history, location, showNotification } = props
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const { createRecord, deleteRecord, fetchRecords, securedSendRequest } = useServices()
  const [cargoTemplateDialog, setCargoTemplateDialog] = useState(false)

  const [lookups, setLookups] = useState(null)
  const [confirmDialog, setConfirmDialog] = useState({ open: false, cargo: null })
  const [massDeleteConfirmDialog, setMassDeleteConfirmDialog] = useState({ open: false, idList: null })
  const theme = useTheme()
  const tableRef = useRef(null)

  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.ACI_HIGHWAY_CARGO
  ])
  //const translatedTextsObject = makeTranslatedTextsObject()
  const { getTranslatedText } = useContext(ACIHighwayTranslationContext)
  const aciHighwayCargoTranslationText = ACIHighwayCargoTranslationText() 
  const whiteLabelServiceSettings = useWhiteLabelServiceSettings("aci-highway")
  const [quickGlanceResponseLogDialog, setQuickGlanceResponseLogDialog] = useState({
    open: false,
    cargo: null
  })
  useEffect(() => {
    Promise.all([
      // Status
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACIHWY_STATUS' }],
        undefined,
        'code'
      ),
      // First expected port
      fetchRecords.execute(
        NaCodeMaintenanceApiURLs.GET,
        {
          filters: [
            { field: 'indicator', operator: EQUAL, value: 'ACI' }
          ],
          customData: { codeMType: 'CustomsOffice' }
        },
        (res) => {
          const result = {}

          res.content.forEach((item) => {
            result[item.code] = item.descriptionEn
          })

          return result
        }
      ),
      // Expected Time Zone
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [
          {
            field: 'codeType',
            operator: EQUAL,
            value: 'SCHEDULER_TIME_ZONE'
          }
        ],
        undefined,
        'code'
      ),
      // Arrival date time zone
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'SCHEDULER_TIME_ZONE' }],
        undefined,
        'code'
      )
    ]).then(([status, firstExpectedPort, timeZone, arrivalDateAndTimeZone, tripNo]) => {
      setLookups({
        status,
        firstExpectedPort,
        timeZone,
        arrivalDateAndTimeZone,
        tripNo
      })
    })
  }, [])

 /* function makeTranslatedTextsObject() {
    let aciHighway = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: aciHighway
      }
    )
    let cargoType = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.CARGO_TYPE
    )
    let attachSentRecord = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ATTACH_SENT
    )
    let attach = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ATTACH
    )
    let consolidated = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.CONSOLIDATED
    )
    let carrierCode = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.CARRIER_CODE
    )
    let ccn = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.CCN)
    let firstExpectedPort = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.FIRST_EXPECTED_PORT
    )
    let arrivalDateAndTime = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ARRIVAL_DATE_AND_TIME
    )
    let arrivalDateAndTimeZone = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ARRIVAL_DATE_AND_TIME_ZONE
    )
    let entryNo = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ENTRY_NO
    )
    let paperRelease = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.PAPER_RELEASE
    )
    let inbondDestinationOfficeCode = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.INBOND_DESTINATION_OFFICE_CODE
    )
    let warehouseCode = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.WAREHOUSE_CODE
    )
    let polCity = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.POL_CITY
    )
    let polCountryCode = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.POL_COUNTRY_CODE
    )
    let polStateCode = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.POL_STATE_CODE
    )
    let poaCity = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.POA_CITY
    )
    let poaCountryCode = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.POA_COUNTRY_CODE
    )
    let poaStateCode = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.POA_STATE_CODE
    )
    let adminName = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ADMIN_NAME
    )
    let adminContact = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ADMIN_CONTACT
    )
    let specialInstructions = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.SPECIAL_INSTRUCTIONS
    )
    let portOfExit = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.PORT_OF_EXIT
    )
    let acquittalNo = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ACQUITTAL_NO
    )
    let date = translate(Namespace.ACI_HIGHWAY_CARGO, AciHighwayCargoKeys.DATE)
    let printRemarks = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.PRINT_REMARKS
    )
    let messageFunction = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.MESSAGE_FUNCTION
    )
    let status = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.STATUS
    )
    let reviewStatus = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.REVIEW_STATUS
    )
    let tripNo = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.TRIP_NO
    )
    let editMultipleRecords = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.EDIT_MULTIPLE_RECORDS
    )
    let editSentRecords = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.EDIT_SENT_RECORDS
    )
    let editButton = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.EDIT_BUTTON
    )
    let viewButton = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.VIEW_BUTTON
    )
    let cloneButton = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.CLONE_BUTTON
    )
    let cancelButton = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.CANCEL_BUTTON
    )
    let cancel = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.CANCEL
    )
    let submitButton = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.SUBMIT_BUTTON
    )
    let deleteButton = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.DELETE_BUTTON
    )
    let viewMultipleRecords = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.VIEW_MULTIPLE_RECORDS
    )
    let cloneMultipleRecords = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.CLONE_MULTIPLE_RECORDS
    )
    let deleteMultipleRecords = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.DELETE_MULTIPLE_RECORDS
    )
    let submitSentRecord = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.SUBMIT_SENT_RECORD
    )
    let submitSuccessMsg = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.SUBMIT_SUCCESS_MSG
    )
    let submitErrorMsg = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.SUBMIT_ERROR_MSG
    )
    let submitRecordDialogContent = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.SUBMIT_RECORD_DIALOG_CONTENT
    )
    let submitRecord = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.SUBMIT_RECORD
    )
    let createdDateTime = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.CREATIONDATETIME
    )
    let submittedDate = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.SUBMITTED_DATE_TIME
    )
    let attachCargoMessage = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ATTACH_CARGO_MSG
    )
    let attachCargoSuccessMsg = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.ATTACH_CARGO_SUCESS_MSG
    )
    let printA8A = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.PRINT_A8A
    )
    let printA49 = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.PRINT_A49
    )
    let printMultipleRecords = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.PRINT_MULTIPLE_RECORDS
    )
    let consigneeName = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.CONSIGNEE_NAME
    )
    let shipperName = translate(
      Namespace.ACI_HIGHWAY_CARGO,
      AciHighwayCargoKeys.SHIPPER_NAME
    )

    return {
      aciHighway,
      tableTitle,
      cargoType,
      consolidated,
      carrierCode,
      ccn,
      cancel,
      attachCargoMessage,
      attachCargoSuccessMsg,
      firstExpectedPort,
      arrivalDateAndTime,
      arrivalDateAndTimeZone,
      entryNo,
      paperRelease,
      inbondDestinationOfficeCode,
      warehouseCode,
      polCity,
      polCountryCode,
      polStateCode,
      poaCity,
      poaCountryCode,
      poaStateCode,
      adminName,
      adminContact,
      specialInstructions,
      portOfExit,
      acquittalNo,
      date,
      printRemarks,
      messageFunction,
      status,
      reviewStatus,
      tripNo,
      attachSentRecord,
      attach,
      editMultipleRecords,
      editSentRecords,
      editButton,
      viewButton,
      cloneButton,
      cancelButton,
      submitButton,
      deleteButton,
      viewMultipleRecords,
      cloneMultipleRecords,
      deleteMultipleRecords,
      submitSentRecord,
      submitSuccessMsg,
      submitErrorMsg,
      submitRecordDialogContent,
      submitRecord,
      createdDateTime,
      submittedDate,
      printA8A,
      printA49,
      printMultipleRecords,
      consigneeName,
      shipperName,
    }
  }*/

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  let columns = [
    {
      field: 'cargoType',
      sortKey: 'cargoType',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'cargoType'),
      render: (data) => (
        data.cargoType === "OSC" ? "OTHER" : data.cargoType
      )
    },
    {
      field: 'ccn',
      sortKey: 'ccn',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'ccn')
    },
    {
      field: 'firstExpectedPort',
      sortKey: 'firstExpectedPort',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'firstExpectedPort'),
      render: (data) =>
        <Typography component='div' variant='inherit'>
          {getLookupValue('firstExpectedPort', data.firstExpectedPort)}
          <TinyChip label={data.firstExpectedPort} variant='outlined' />
        </Typography>
    },
    {
      field: 'arrivalDateAndTime',
      sortKey: 'arrivalDateAndTime',
    title: `${getTranslatedText('ACI_HIGHWAY_CARGO', 'arrivalDateAndTime')} & ${getTranslatedText('ACI_HIGHWAY_CARGO', 'arrivalDateAndTimeZone')}`,
      render: (data) =>
        data.arrivalDateAndTime && (
          <Typography component='div' variant='inherit'>
            {data.arrivalDateAndTime &&
              moment(data.arrivalDateAndTime).format('D MMM YYYY, HH:mm')}
            {data.arrivalDateAndTimeZone && (
              <TinyChip label={data.arrivalDateAndTimeZone} variant='outlined' />
            )}
          </Typography>
        )
    },
    {
      field: 'shipperName',
      sortKey: 'shipperName',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'shipperName')
    },
    {
      field: 'consigneeName',
      sortKey: 'consigneeName',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'consigneeName')
    },
    {
      field: 'createdDate',
      sortKey: 'createdDate',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'createdDate'),
      render: (data) =>
        data.createdDate && moment(data.createdDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'submittedDate',
      sortKey: 'submittedDate',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'submittedDate'),
      render: (data) => data.submittedDate && moment(data.submittedDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'entryNo',
      sortKey: 'entryNo',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'entryNo')
    },
    {
      field: 'status',
      sortKey: 'status',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'status'),
      render: (data) => {
        const status = getStatusMetadata(data.status)

        if (data.status == '1000' && data.cargoType == 'REGULAR' && !data.entryNo) {
          status.color = "#ffc400"
          status.contrastColor = "#000000"
        }

        return (
          <Box display='flex' alignItems='baseline' flexDirection='column' style={{ gap: 4 }}>
            <Tooltip key='more' title='View response(s)' placement='top'>
              <Chip
                label={status.label}
                size='small'
                style={{
                  backgroundColor: status.color,
                  color: status.contrastColor
                }}
                clickable
                onClick={(event) => {
                  event.stopPropagation()
                  setQuickGlanceResponseLogDialog({ open: true, cargo: data })
                }}
              />
            </Tooltip>
            {data.portMismatch && (
              <Chip
              label={aciHighwayCargoTranslationText.portMismatch}
                size='small'
                style={{ color: '#ffffff', backgroundColor: '#DF2901' }}
              />
            )}
          </Box>
        )
      }
    },
    {
      field: 'tripNo',
      sortKey: 'tripNo',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'tripNo'),
      render: (data) => {
        var editUrl = `${'/aci-highway/manifest'}/edit/${data.manifestId}`

        return (<div style={{ 'text-decoration': 'underline', cursor: 'pointer' }} onClick={(event) => {
          event.stopPropagation()
          history.push(editUrl)
        }}>{data.tripNo}</div>)
      }
    }
  ]

  let challengerColumns = [
    {
      field: 'apiAutoSubmit',
      sortKey: 'reviewStatus',
    title: getTranslatedText('ACI_HIGHWAY_CARGO', 'reviewStatus'),
      render: (data) => {
        if (data.apiAutoSubmit) {
          const reviewStatus = getStatusMetadata(data.apiAutoSubmit)

          return (
            <>
              <Chip
                label={reviewStatus.label}
                size='small'
                style={{
                  backgroundColor: reviewStatus.color,
                  color: reviewStatus.contrastColor
                }}
              />
            </>
          )
        }
      }
    }
  ]

  if (whiteLabelServiceSettings && whiteLabelServiceSettings.length > 0
    && whiteLabelServiceSettings[0].custom.UI_MANIFEST_CARGO_TABLE_REVIEW_STATUS === 'true') {
    columns = [...columns, ...challengerColumns]
  }

  const filters = [
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','ccn'),
      type: 'textfield',
      name: 'ccn',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','firstExpectedPort'),
      type: 'textfield',
      name: 'firstExpectedPort',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','arrivalDateAndTime'),
      type: 'daterange',
      name: 'arrivalDateAndTime',
      operatorType: BETWEEN
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','shipperName'),
      type: 'textfield',
      name: 'shipperName',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','consigneeName'),
      type: 'textfield',
      name: 'consigneeName',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','tripNo'),
      type: 'textfield',
      name: 'tripNo',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','entryNo'),
      type: 'textfield',
      name: 'entryNo',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','createdDate'),
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','submittedDate'),
      type: 'daterange',
      name: 'submittedDate',
      operatorType: BETWEEN
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','status'),
      type: 'checkbox',
      name: 'status',
      operatorType: IN,
      options: [
        {
          label: aciHighwayCargoTranslationText.draftStatus,
          value: 'draft',
          filterValue: {
            value: '1005'
          }
        },
        {
          label: aciHighwayCargoTranslationText.acceptedStatus,
          value: 'accepted',
          filterValue: {
            value: '1000'
          }
        },
        {
          label: aciHighwayCargoTranslationText.pendingEntryNumberStatus,
          value: 'pending',
          filterValue: {
            value: 'PENDING'
          }
        },
        {
          label: aciHighwayCargoTranslationText.sentStatus,
          value: 'sent',
          filterValue: {
            value: '1008'
          }
        },
        {
          label: aciHighwayCargoTranslationText.rejectedStatus,
          value: 'rejected',
          filterValue: {
            value: '1001'
          }
        },
        {
          label: aciHighwayCargoTranslationText.templateStatus,
          value: 'Template',
          filterValue: {
            value: '1002'
          }
        },
        {
          label: aciHighwayCargoTranslationText.statusNotificationStatus,
          value: 'status_notification',
          filterValue: {
            value: '1006'
          }
        },
        {
          label: aciHighwayCargoTranslationText.cancellationAcceptedStatus,
          value: 'cancellation_accepted',
          filterValue: {
            value: '1003'
          }
        },
        {
          label: aciHighwayCargoTranslationText.cancellationRejectedStatus,
          value: 'cancellation_rejected',
          filterValue: {
            value: '1004'
          }
        },
        {
          label: aciHighwayCargoTranslationText.modificationRejectedStatus,
          value: 'modification_rejected',
          filterValue: {
            value: '1007'
          }
        }
      ]
    },
    {
      label: aciHighwayCargoTranslationText.reviewStatus,
      type: 'checkbox',
      name: 'apiAutoSubmit',
      operatorType: IN,
      options: [
        {
          fullWidth: true,
          label: aciHighwayCargoTranslationText.pendingReview,
          value: 'pending_review',
          filterValue: {
            value: 'R'
          }
        },
        {
          fullWidth: true,
          label: aciHighwayCargoTranslationText.reviewInProgress,
          value: 'review_in_progress',
          filterValue: {
            value: 'Y'
          }
        },
        {
          fullWidth: true,
          label: aciHighwayCargoTranslationText.reviewed,
          value: 'reviewed',
          filterValue: {
            value: 'G'
          }
        }
      ]
    },
    {
      label: getTranslatedText('ACI_HIGHWAY_CARGO','cargoType'),
      type: 'checkbox',
      name: 'cargoType',
      operatorType: IN,
      options: [
        {
          label: aciHighwayCargoTranslationText.regularShipment,
          value: 'REGULAR',
          filterValue: {
            value: 'REGULAR'
          }
        },
        {
          label: aciHighwayCargoTranslationText.inbondShipment,
          value: 'IN-BOND',
          filterValue: {
            value: 'IN-BOND'
          }
        },
        {
          label: aciHighwayCargoTranslationText.csaShipment,
          value: 'CSA',
          filterValue: {
            value: 'CSA'
          }
        },
        {
          label: aciHighwayCargoTranslationText.otherSystemCargo,
          value: 'OSC',
          filterValue: {
            value: 'OSC'
          }
        }
      ]
    }
  ]

  function handleCloneCargo(data) {
    data.cloneFrom = data.ccn;
    createRecord.execute(
      AciHighwayCargoApiUrls.CLONE,
      data,
      (data) => {
        const commodityData = data.cargoCommodity.map(
          (cargoCommodity, index) => ({ ...cargoCommodity, _id: index + 1 })
        )
        data.cargoCommodity = commodityData

        const partyData = data.cargoParties.map(
          (cargoParties, index) => ({ ...cargoParties, _id: index + 1 })
        )
        data.cargoParties = partyData

        data.arrivalTime = moment(data.arrivalDateAndTime).format('HH:mm');
        data.arrivalDate = moment(data.arrivalDateAndTime).format('YYYY-MM-DD');

        history.push(pathMap.ACI_HW_CARGO_ADD_VIEW, data)
      },
      (error) => {
        console.log(error)
      }
    )
  }

  function handleMassDeleteCargo() {
    if (massDeleteConfirmDialog.idList) {
      setMassDeleteConfirmDialog({ open: false })
      sweetalert(aciHighwayCargoTranslationText.cargoDeleteInProgressMsg, "", "success");
      securedSendRequest.execute('POST',
        AciHighwayCargoApiUrls.MASS_DELETE,
        massDeleteConfirmDialog.idList,
        () => {
          showNotification('success', aciHighwayCargoTranslationText.cargoMassDeleteSucceeded)
          setMassDeleteConfirmDialog({ open: false, idList: null })
          tableRef.current.performRefresh()
        },
        (error) => {
          showNotification('error', aciHighwayCargoTranslationText.cargoMassDeleteError)
          console.log(error)
        }
      )
    }
  }

  function handleDeleteCargo() {
    if (confirmDialog.cargo) {
      deleteRecord.execute(
        AciHighwayCargoApiUrls.DELETE,
        confirmDialog.cargo,
        () => {
          showNotification('success', aciHighwayCargoTranslationText.cargoDeleteSucceeded)
          setConfirmDialog({ open: false, cargo: null })
          setCargoTemplateDialog(false);
          tableRef.current.performRefresh()
        },
        (error) => {
          console.log(error)
        }
      )
    }
  }

  function handlePrintA8A(data) {
    const config = { responseType: 'blob' }
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      data.fileForUserId = fileForUserDetails.fileForUserId;
      data.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      data.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }
    securedSendRequest.execute(
      'POST',
      AciHighwayCargoApiUrls.PRINT,
      data,
      (response) => {
        let blob = new Blob([response.data])

        let first = 'ACIHW_CARGO_A8A_'
        let curDate = format(new Date(), 'yyyyMMddHHmmss')
        let filename = first + curDate + '.pdf'
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
      },
      (error) => console.error(error),
      undefined,
      config,
      null
    )
  }

  function handlePrintA49(data) {
    const config = { responseType: 'blob' }
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      data.fileForUserId = fileForUserDetails.fileForUserId;
      data.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      data.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }
    securedSendRequest.execute(
      'POST',
      AciHighwayCargoApiUrls.PRINTA49,
      data,
      (response) => {
        let blob = new Blob([response.data])

        let first = 'ACIHW_CARGO_A49_'
        let curDate = format(new Date(), 'yyyyMMddHHmmss')
        let filename = first + curDate + '.pdf'
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
      },
      (error) => console.error(error),
      undefined,
      config,
      null
    )
  }

  async function exportCargo(data) {
    if (data.length > 0) {
      const config = { responseType: 'blob' }

      securedSendRequest.execute('POST', AciHighwayCargoApiUrls.EXPORT_CARGO, data,
        (response) => {
          let blob = new Blob([response.data])

          let first = 'ACIHW_CARGO_EXPORT_'
          let curDate = format(new Date(), 'yyyyMMddHHmmss')
          let filename = first + curDate + '.csv'
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          a.href = url
          a.download = filename
          a.click()
        },
        (error) => console.error(error),
        undefined,
        config,
        null
      )
    }
  }

  return (
    <>
      <Table
        actions={[
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.ACI_HW_CARGO_ADD_VIEW)
            },
            label: aciHighwayCargoTranslationText.createCargoButton
          },
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => setCargoTemplateDialog(true)
            },
            label: aciHighwayCargoTranslationText.cargoTemplateButton
          }
        ]}
        columns={columns}
        compact
        exportData={{ url: AciHighwayCargoApiUrls.EXPORT }}
        fetch={{ url: AciHighwayCargoApiUrls.GET }}
        fetchFilters={[
          { field: 'templateFlag', operator: EQUAL, value: '0' },
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() }
        ]}
        filters={filters}
        onRowClick={(rowData) => {
          if (rowData.status === '1008') {
            history.push(`${location.pathname}/view/${rowData.id}`)
          }
          else {
            history.push(`${location.pathname}/edit/${rowData.id}`)
          }
        }
        }
        rowActions={[
          {
            disabled: (rowData) => rowData.status === '1008',
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: aciHighwayCargoTranslationText.editButton,
            onClick: (rowData) =>
              history.push(`${location.pathname}/edit/${rowData.id}`),
            tooltip: (rowData) =>
              rowData.status === '1008'
                ? aciHighwayCargoTranslationText.editSentRecords
                : null
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
            label: aciHighwayCargoTranslationText.cloneButton,
            onClick: handleCloneCargo
          },
          {
            disabled: (rowData) => rowData.status !== '1005',
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: aciHighwayCargoTranslationText.deleteButton,
            onClick: (rowData) => setConfirmDialog({ open: true, cargo: rowData }),
            tooltip: (rowData) =>
              rowData.status !== '1005'
                ? aciHighwayCargoTranslationText.deleteMultipleRecords
                : null
          },
          {
            label: getTranslatedText('ACI_HIGHWAY_CARGO','printA8A'),
            icon: <FontAwesomeIcon icon={['fal', 'print']} />,
            onClick: handlePrintA8A
          },
          {
            label: getTranslatedText('ACI_HIGHWAY_CARGO','printA49'),
            icon: <FontAwesomeIcon icon={['fal', 'print']} />,
            onClick: handlePrintA49
          }
        ]}
        showNotification={showNotification}
        sortConfig={{
          type: 'column',
          defaultDirection: 'DESC',
          defaultField: 'createdDate'
        }}
        persistSettings
        tableRef={tableRef}
        checkboxSelection
        selectActions={[
          {
            // disabled: (rows) => rows.length > 500,
            icon: <FontAwesomeIcon icon={['fal', 'link']} />,
            label: aciHighwayCargoTranslationText.exportCargoButton,
            onClick: (rows) => {
              if (rows.length > 500) {
                sweetalert(aciHighwayCargoTranslationText.maxRecordExportMsg, "", "error");
              } else {
                sweetalert(aciHighwayCargoTranslationText.exportCargoBackgroundMsg, "", "success");
                return exportCargo(rows);
              }
            },
            tooltip: (rows) => rows.length > 500 ? aciHighwayCargoTranslationText.maxRecordExportMsg : null
          },
          {
            disabled: (rows) => {
              let disable = false;
              rows.forEach(e => {
                if (e.status !== '1005') { disable = true }
              })
              return disable;
            },
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: aciHighwayCargoTranslationText.massDeleteButton,
            tooltip: (rows) => {
              let description = null;
              rows.forEach(e => {
                if (e.status !== '1005') { description = aciHighwayCargoTranslationText.deleteMultipleRecords }
              })
              return description;
            },
            buttonProps: {
              size: 'medium',
              color: 'secondary',
              style: { color: theme.palette.error.main, minWidth: 'auto' }
            },
            onClick: (rows) => {
              let idList = rows.map(e => e.id)
              setMassDeleteConfirmDialog({ open: true, idList: idList });
            }
          }
        ]}
      />
      <TemplateSelectDialogWithOptionACIHWYCargo
        cargoTemplateDialog={cargoTemplateDialog}
        setCargoTemplateDialog={setCargoTemplateDialog}
        setConfirmDialog={setConfirmDialog}
        showNotification={showNotification}
        getTranslatedText={getTranslatedText}
        //translatedTextsObject={translatedTextsObject}
        isTable={true}
        location={location}
        rowActions={[
          {
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: aciHighwayCargoTranslationText.editButton,
            onClick: (rowData) => {
              history.push(pathMap.ACI_HW_CARGO + `/edit/${rowData.id}`)
            },
            tooltip: () => 'edit'
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: aciHighwayCargoTranslationText.deleteButton,
            onClick: (rowData) =>
              setConfirmDialog({ open: true, cargo: rowData }),
            tooltip: () => 'delete'
          }
        ]}
      />
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog.open}
        closeDialog={() => setConfirmDialog({ open: false, cargo: null })}
        confirmDialog={handleDeleteCargo}
        content={aciHighwayCargoTranslationText.deleteContentMsg}
        okMsg={aciHighwayCargoTranslationText.deleteConfirmMsg}
        cancelMsg={aciHighwayCargoTranslationText.deleteCancelMsg}
        title={aciHighwayCargoTranslationText.deleteButton}
      />
      <ConfirmDialog
        isConfirmDialogOpen={massDeleteConfirmDialog.open}
        closeDialog={() => setMassDeleteConfirmDialog({ open: false, idList: null })}
        confirmDialog={handleMassDeleteCargo}
        content={aciHighwayCargoTranslationText.deleteContentMsg}
        okMsg={aciHighwayCargoTranslationText.deleteConfirmMsg}
        cancelMsg={aciHighwayCargoTranslationText.deleteCancelMsg}
        title={aciHighwayCargoTranslationText.deleteButton}
      />
      <QuickGlanceResponseLogDialog
        getLookupValue={getLookupValue}
        cargo={quickGlanceResponseLogDialog.cargo}
        onClose={() => setQuickGlanceResponseLogDialog({ open: false, cargo: null })}
        open={quickGlanceResponseLogDialog.open}
       // translatedTextsObject={translatedTextsObject}
      />
    </>
  )
}

export default TablePage
function QuickGlanceResponseLogDialog(props) {
  const { getLookupValue, cargo, onClose, open, translatedTextsObject } = props
  const { securedSendRequest } = useServices()
  const theme = useTheme()
  const [statusList, setStatusList] = useState([])
  const [redirectUrl, setRedirectUrl] = useState()
  const aciHighwayCargoTranslationText = ACIHighwayCargoTranslationText() 

  const redirectData = {
    manifestData: { ...cargo },
    step: "2"
  }

  let content = cargo ? (
    <Grid item xs={12}>
      <ResponseMessage
        id={cargo.id}
        isViewOnly={true}
        ccnValue={cargo.ccn}
        manifestId={cargo.manifestId}
        cargoPage={true}
        manifestPage={false}
      />
    </Grid>
  ) : null
  return (
    <CngDialog
      dialogContent={content}
      dialogAction={<CngButton onClick={onClose}>OK</CngButton>}
      dialogTitle={aciHighwayCargoTranslationText.responseLogTab}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='lg'
      onClose={onClose}
      open={open}
      shouldShowCloseButton
    />
  )

}